document.addEventListener("DOMContentLoaded", function() {

      const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
    prevBtn.addEventListener('click', embla.scrollPrev, false);
    nextBtn.addEventListener('click', embla.scrollNext, false);
  };

  const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
    return () => {
      if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');
      else prevBtn.setAttribute('disabled', 'disabled');

      if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');
      else nextBtn.setAttribute('disabled', 'disabled');
    };
  };


  const setupDotBtns = (dotsArray, embla) => {
    dotsArray.forEach((dotNode, i) => {
      dotNode.addEventListener("click", () => embla.scrollTo(i), false);
    });
  };

const generateDotBtns = (dots, embla, template) => {
    dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + template, "");
    return [].slice.call(dots.querySelectorAll(".embla__dot"));
  };

  const selectDotBtn = (dotsArray, embla) => () => {
    let previous = embla.previousScrollSnap();
    let selected = embla.selectedScrollSnap();
    dotsArray[previous].classList.remove("is-selected");
    dotsArray[selected].classList.add("is-selected");
  };
  
  // Initialize all carousels on the page
  document.querySelectorAll('.embla').forEach(function(emblaNode) {
    
    let viewPort = emblaNode.querySelector('.embla__viewport');
    let prevBtn = emblaNode.querySelector('.embla__button--prev');
    let nextBtn = emblaNode.querySelector('.embla__button--next');
    let dots = emblaNode.querySelector('.embla__dots');
    // let template = emblaNode.querySelector(".embla-dot-template").innerHTML;  
     
    let embla = new EmblaCarousel(viewPort, { loop: true });

    // let dotsArray = generateDotBtns(dots, embla, template);
    // let setSelectedDotBtn = selectDotBtn(dotsArray, embla);
    let disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);

    setupPrevNextBtns(prevBtn, nextBtn, embla);
    //setupDotBtns(dotsArray, embla);

   // embla.on("select", setSelectedDotBtn);
    embla.on("select", disablePrevAndNextBtns);
    //embla.on("init", setSelectedDotBtn);
    embla.on("init", disablePrevAndNextBtns);
  });
});